import { useEffect, useState } from "react";
import { adminApi } from "../lib/api";
import { Cloud, CloudOff, RefreshCcw } from "lucide-react";

export default function PinnacleStatusIndicator() {
  const [status, setStatus] = useState({ mode: "csv", online: true, pending: 0, failed: 0, label: "…" });

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await adminApi.get("/pinnacle/status");
        setStatus(data);
      } catch {
        // ignore
      }
    };
    load();
    const t = setInterval(load, 15000);
    return () => clearInterval(t);
  }, []);

  const Icon = status.online ? Cloud : CloudOff;

  return (
    <div
      data-testid="pinnacle-status"
      className={`flex items-center gap-2 px-3 h-8 rounded-sm border text-[11px] font-mono uppercase tracking-[0.15em] ${
        status.online ? "border-green-500/40 bg-green-500/10 text-green-400" : "border-red-500/40 bg-red-500/10 text-red-400"
      }`}
    >
      <Icon className="h-3.5 w-3.5" />
      <span>Pinnacle · {status.label}</span>
      {status.pending > 0 && (
        <span className="ml-1 inline-flex items-center gap-1 text-yellow-300" data-testid="pinnacle-pending-count">
          <RefreshCcw className="h-3 w-3" /> {status.pending} queued
        </span>
      )}
      {status.failed > 0 && (
        <span className="ml-1 text-red-300">· {status.failed} failed</span>
      )}
    </div>
  );
}
